import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'

const searchIconVariants = cva('', {
  variants: {
    filled: {
      true: '[&_[data-filled]]:fill-[currentColor] [&_[data-stroke]]:fill-[transparent]',
      false: '[&_[data-filled]]:fill-[transparent] [&_[data-stroke]]:fill-[currentColor]',
    },
  },
})

export function SearchIcon({
  className,
  size = 20,
  filled = false,
  ...props
}: IconProps & VariantProps<typeof searchIconVariants>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size }), searchIconVariants({ filled }), className)}
      {...props}
    >
      <path
        data-filled
        d="M16.9214 16.3794C18.2128 14.9587 19 13.0713 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C12.8214 19 14.5006 18.3913 15.8453 17.3663C15.8851 17.4375 15.9373 17.5033 16.0017 17.5606L20.5017 21.5606C20.8113 21.8357 21.2854 21.8079 21.5606 21.4983C21.8357 21.1887 21.8079 20.7146 21.4983 20.4394L16.9983 16.4394C16.9736 16.4175 16.9479 16.3975 16.9214 16.3794Z"
        fill="currentColor"
      />
      <path
        data-stroke
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8453 17.3663C14.5006 18.3913 12.8214 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 13.0713 18.2128 14.9587 16.9214 16.3794C16.9479 16.3975 16.9736 16.4175 16.9983 16.4394L21.4983 20.4394C21.8079 20.7146 21.8357 21.1887 21.5606 21.4983C21.2854 21.8079 20.8113 21.8357 20.5017 21.5606L16.0017 17.5606C15.9373 17.5033 15.8851 17.4375 15.8453 17.3663ZM17.5 11C17.5 14.5899 14.5899 17.5 11 17.5C7.41015 17.5 4.5 14.5899 4.5 11C4.5 7.41015 7.41015 4.5 11 4.5C14.5899 4.5 17.5 7.41015 17.5 11Z"
        fill="currentColor"
      />
    </svg>
  )
}
